import { useState, useMemo, useCallback } from "react";
import { getSelectedTags, getSelectedTagsId } from "../services/utils";

/**
 * Хранит список опций мультиселекта и производные от него значения.
 *
 * @param {Array} initialValues массив вида [{ id, name, checked }]
 */
const useMultiSelectValues = (initialValues) => {
    const [values, setValues] = useState(initialValues || []);

    // производные значения — не держим их в отдельном состоянии,
    // иначе они рассинхронизируются с values
    const tags = useMemo(() => getSelectedTags(values), [values]);
    const selectedIds = useMemo(() => getSelectedTagsId(values), [values]);
    const checkedAll = useMemo(
        () => values.length > 0 && values.every(item => item.checked),
        [values],
    );

    // переключить одну опцию по её name
    const toggleByName = useCallback((name) => {
        setValues(prev => prev.map(item => (
            item.name === name ? { ...item, checked: !item.checked } : item
        )));
    }, []);

    // выбрать/снять все
    const toggleAll = useCallback(() => {
        setValues(prev => {
            const nextChecked = !prev.every(item => item.checked);
            return prev.map(item => ({ ...item, checked: nextChecked }));
        });
    }, []);

    return { values, tags, selectedIds, checkedAll, toggleByName, toggleAll };
};

export default useMultiSelectValues;
